import { ExportOptions, ExportPayloadSection } from '../../types';
import hasTextExportDecoration from '../hasTextExportDecoration';
import resolveCellValue from '../resolveCellValue';
import resolveRoundedValue from '../resolveRoundedValue';
import resolveTextCellValue from '../resolveTextCellValue';

const resolveJsonCellValue = (
  row: Record<string, unknown>,
  column: ExportPayloadSection['columns'][number],
  options: ExportOptions
): unknown => {
  if (options.jsonValueMode === 'string') {
    return resolveTextCellValue(row, column, options);
  }

  const rawValue = row[column.name];

  // Typed mode keeps an empty string distinct from a missing value.
  if (rawValue === '') {
    return '';
  }

  if (rawValue === null || rawValue === undefined) {
    return null;
  }

  if (!hasTextExportDecoration(column.exportOptions)) {
    return resolveRoundedValue(rawValue, column.exportOptions);
  }

  // A typed value can't carry a prefix/suffix or a length limit, and typed mode hides
  // display formatting, so decorated columns fall back to an undecorated text pipeline.
  return resolveCellValue(row, column, {
    ...options,
    useDisplayFormatting: false,
    decimalSeparator: 'display',
  });
};

export default resolveJsonCellValue;
